// import gumLogo from "../assets/gum_logo.svg";

export function LoginBox({ children }: { children: React.ReactNode }) {
  return (
    <>
      {/* <div className="flex items-stretch h-16 bg-gray-100 absolute top-0 left-0 right-0">
        <img
          alt="Logo - Sunstar GUM"
          loading="lazy"
          width="150"
          height="40"
          decoding="async"
          style={{ color: "transparent" }}
          src={gumLogo}
        />
      </div> */}
      <div className="w-full h-full min-h-screen bg-gray-100 flex align-middle content-center items-start sm:items-center justify-center pt-[4vh] sm:pt-0">
        <div className="container mx-auto h-full grid content-start sm:content-center">
          <main className="relative bg-white shadow-lg shadow-gray-500/10 mx-4 my-2 sm:mx-auto sm:max-w-[468px] sm:w-[468px] rounded-xl p-4 sm:p-8 sm:py-4">
            <div className="flex justify-center items-stretch h-24">
              <img
                alt="Logo - Sunstar GUM"
                loading="lazy"
                width="300"
                height="40"
                decoding="async"
                style={{ color: "transparent" }}
                src="/gum_logo.svg"
              />
            </div>

            {children}
          </main>
        </div>
      </div>
    </>
  );
}
